(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xenohallowen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STORE_KEY = 'hw_codigo_halloween';

    function store(action, value) {
      try {
        if (action === 'get') return localStorage.getItem(STORE_KEY);
        if (action === 'set') localStorage.setItem(STORE_KEY, value);
        if (action === 'del') localStorage.removeItem(STORE_KEY);
      } catch (e) { /* almacenamiento no disponible */ }
      return null;
    }

    /* ---------- Vigilar cambios del carrito hechos por el tema (una sola vez) ---------- */
    var cartListeners = [];
    if (!window.__hwFetchPatched && window.fetch) {
      window.__hwFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0]);
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { cartListeners.forEach(function (fn) { fn(); }); }).catch(function () {});
        }
        return p;
      };
    }

    function init(root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');

      var q = function (name) { return root.querySelector('[data-hw="' + name + '"]'); };
      var siteRoot = root.getAttribute('data-root') || '/';
      var locale = root.getAttribute('data-locale') || document.documentElement.lang || 'es';
      var codes = [];
      try { codes = JSON.parse(q('codes').textContent || '[]'); } catch (e) { codes = []; }
      codes = codes.filter(function (c) { return c.code; });

      var state = { code: null, cart: null };

      /* ---------- Utilidades ---------- */
      function fmtMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
        } catch (e) { return (cents / 100).toFixed(2) + ' ' + (currency || ''); }
      }
      function fmtDate(iso) {
        return new Date(iso + 'T12:00:00').toLocaleDateString(locale, { day: 'numeric', month: 'long' });
      }
      function findCode(code) {
        for (var i = 0; i < codes.length; i++) if (codes[i].code === code) return codes[i];
        return null;
      }
      function startOf(c) { return new Date(c.starts + 'T00:00:00'); }
      function endOf(c) { return new Date(c.expires + 'T23:59:59'); }

      /* ---------- Barra superior: último código publicado ---------- */
      function updateBar() {
        var bar = q('bar');
        if (!bar) return;
        var text = q('bar-text'), copy = q('copy');
        var now = new Date(), featured = null, first = null;
        codes.forEach(function (c) {
          if (!c.starts || !c.expires) return;
          var s = startOf(c), e = endOf(c);
          if (!first || s < first) first = s;
          if (now >= s && now <= e && (!featured || s >= startOf(featured))) featured = c;
        });
        var prefix = root.getAttribute('data-bar-prefix') || '';
        var soon = root.getAttribute('data-bar-soon') || '';
        if (featured) {
          bar.style.display = '';
          text.innerHTML = '';
          var b = document.createElement('b'); b.textContent = prefix;
          text.appendChild(b);
          text.appendChild(document.createTextNode(' ' + (featured.label || '') + ' con'));
          copy.style.display = ''; copy.textContent = featured.code;
        } else if (first && now < first) {
          bar.style.display = '';
          text.textContent = soon.replace('{fecha}', fmtDate(first.toISOString().slice(0, 10)));
          copy.style.display = 'none';
        } else {
          bar.style.display = 'none';
        }
      }

      /* ---------- Carrito ---------- */
      function renderCart() {
        var cart = state.cart;
        if (!cart) return;
        q('cart-count').textContent = cart.item_count;
        var totalEl = q('cart-total');
        var disc = cart.total_discount || 0;
        if (disc > 0) {
          totalEl.innerHTML = '';
          var s = document.createElement('s');
          s.textContent = fmtMoney(cart.original_total_price, cart.currency);
          totalEl.appendChild(s);
          totalEl.appendChild(document.createTextNode(fmtMoney(cart.total_price, cart.currency)));
        } else {
          totalEl.textContent = fmtMoney(cart.total_price, cart.currency);
        }
      }
      function refreshCart() {
        return fetch(siteRoot + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { state.cart = cart; renderCart(); renderCode(); return cart; })
          .catch(function () {});
      }
      cartListeners.push(refreshCart);

      /* ---------- Códigos ---------- */
      function showMsg(text, kind) {
        var m = q('msg'); if (!m) return;
        m.textContent = text; m.className = 'hw-msg ' + (kind || '');
      }

      function validate(raw) {
        var code = String(raw || '').trim().toUpperCase();
        if (!code) return { ok: false, error: 'Escribe un código.' };
        var def = findCode(code);
        if (def) {
          var now = new Date();
          if (def.starts && now < startOf(def)) {
            return { ok: false, error: 'Este código aún no está disponible. Se publica el ' + fmtDate(def.starts) + '.' };
          }
          if (def.expires && now > endOf(def)) {
            return { ok: false, error: 'Este código ha caducado.' };
          }
        }
        return { ok: true, code: code, def: def };
      }

      function renderCode() {
        var btn = q('code-btn');
        if (!btn) return;
        var box = q('applied'), hint = q('hint');
        var def = state.code ? findCode(state.code) : null;
        btn.classList.toggle('has-code', !!state.code);
        q('code-label').textContent = state.code || 'Código';
        box.classList.toggle('show', !!state.code);
        if (state.code) {
          var disc = state.cart && state.cart.total_discount || 0;
          var extra = disc > 0
            ? 'Ahorras ' + fmtMoney(disc, state.cart.currency)
            : 'Se comprobará al pagar';
          q('applied-text').textContent = state.code + ' · ' + extra;
          hint.textContent = def && def.label ? def.label : '';
        } else {
          hint.textContent = '';
        }
      }

      function applyCode(raw) {
        var v = validate(raw);
        if (!v.ok) { showMsg(v.error, 'err'); return; }
        var apply = q('apply');
        apply.disabled = true;
        showMsg('Comprobando…', '');
        // /discount/CODIGO guarda el código en la sesión; Shopify lo valida de verdad
        fetch(siteRoot + 'discount/' + encodeURIComponent(v.code) + '?redirect=' + encodeURIComponent(siteRoot + 'cart.js'), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            state.code = v.code;
            state.cart = cart;
            store('set', v.code);
            var disc = cart.total_discount || 0;
            if (disc > 0) {
              showMsg('Código aplicado.', 'ok');
            } else if (!cart.item_count) {
              showMsg('Código guardado. Se aplicará cuando añadas productos.', 'ok');
            } else {
              showMsg('Código guardado, pero no se ve descuento en tu carrito. Puede que no llegues a la compra mínima; se comprueba de nuevo al pagar.', 'err');
            }
            renderCart(); renderCode();
          })
          .catch(function () { showMsg('No se pudo aplicar el código. Inténtalo de nuevo.', 'err'); })
          .then(function () { apply.disabled = false; });
      }

      function togglePanel(force) {
        var panel = q('panel'), btn = q('code-btn');
        if (!panel) return;
        var open = typeof force === 'boolean' ? force : !panel.classList.contains('open');
        panel.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open);
        if (open) setTimeout(function () { q('input').focus(); }, 0);
      }

      /* ---------- Eventos ---------- */
      if (q('code-btn')) {
        q('code-btn').addEventListener('click', function () { togglePanel(); });
        q('form').addEventListener('submit', function (e) { e.preventDefault(); applyCode(q('input').value); });
        q('change').addEventListener('click', function () { q('input').value = ''; q('input').focus(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') togglePanel(false); });
        document.addEventListener('click', function (e) {
          if (!q('panel').contains(e.target) && !q('code-btn').contains(e.target)) togglePanel(false);
        });
      }

      if (q('copy')) {
        q('copy').addEventListener('click', function () {
          var code = this.textContent.trim(), btn = this;
          function done() {
            btn.textContent = '¡Copiado!';
            setTimeout(function () { btn.textContent = code; }, 1500);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, done);
          } else { done(); }
          if (q('input')) { q('input').value = code; applyCode(code); }
        });
      }

      q('burger').addEventListener('click', function () {
        var nav = q('nav'), open = !nav.classList.contains('open');
        nav.classList.toggle('open', open);
        this.setAttribute('aria-expanded', open);
      });

      window.addEventListener('pageshow', refreshCart);

      /* ---------- Murciélagos y brasas ---------- */
      (function fx() {
        var canvas = q('fx');
        if (root.getAttribute('data-fx') !== 'true' || !canvas || !canvas.getContext) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var ctx = canvas.getContext('2d');
        var embers = [], bats = [], w = 0, h = 0, raf = null, t = 0;

        function resize() {
          var r = canvas.parentElement.getBoundingClientRect();
          var dpr = Math.min(window.devicePixelRatio || 1, 2);
          w = r.width; h = r.height;
          canvas.width = w * dpr; canvas.height = h * dpr;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          var n = Math.round(w / 40);
          embers = [];
          for (var i = 0; i < n; i++) embers.push(makeEmber(true));
        }
        function makeEmber(anywhere) {
          return { x: Math.random() * w, y: anywhere ? Math.random() * h : h + 4,
                   r: Math.random() * 1.6 + .5, s: Math.random() * .35 + .12, d: Math.random() * 6.28,
                   a: Math.random() * .5 + .35 };
        }
        function makeBat() {
          var dir = Math.random() < .5 ? 1 : -1;
          return { x: dir === 1 ? -30 : w + 30, y: Math.random() * (h * .6) + 10,
                   vx: dir * (Math.random() + 1.1), size: Math.random() * 6 + 9, ph: Math.random() * 6.28 };
        }
        function drawBat(b) {
          var s = b.size, f = Math.sin(t * .35 + b.ph);
          ctx.save();
          ctx.translate(b.x, b.y + Math.sin(t * .05 + b.ph) * 6);
          ctx.fillStyle = 'rgba(160,110,225,.9)';
          ctx.beginPath(); ctx.ellipse(0, 0, s * .2, s * .32, 0, 0, 6.283); ctx.fill();
          ctx.beginPath();
          ctx.moveTo(-s * .12, -s * .24); ctx.lineTo(-s * .16, -s * .5); ctx.lineTo(-s * .02, -s * .3);
          ctx.moveTo(s * .12, -s * .24); ctx.lineTo(s * .16, -s * .5); ctx.lineTo(s * .02, -s * .3);
          ctx.fill();
          [-1, 1].forEach(function (side) {
            var tip = -s * .5 * f;
            ctx.beginPath();
            ctx.moveTo(side * s * .14, -s * .05);
            ctx.quadraticCurveTo(side * s * .55, tip - s * .35, side * s * 1.1, tip);
            ctx.quadraticCurveTo(side * s * .85, tip + s * .3, side * s * .62, tip + s * .24);
            ctx.quadraticCurveTo(side * s * .45, tip + s * .5, side * s * .14, s * .22);
            ctx.closePath(); ctx.fill();
          });
          ctx.restore();
        }
        function tick() {
          t++;
          ctx.clearRect(0, 0, w, h);
          for (var i = 0; i < embers.length; i++) {
            var e = embers[i];
            e.y -= e.s; e.d += .015; e.x += Math.sin(e.d) * .3;
            if (e.y < -4) embers[i] = makeEmber(false);
            ctx.fillStyle = 'rgba(255,140,40,' + e.a + ')';
            ctx.beginPath(); ctx.arc(e.x, e.y, e.r, 0, 6.283); ctx.fill();
          }
          if (bats.length < 2 && Math.random() < .004) bats.push(makeBat());
          for (var j = bats.length - 1; j >= 0; j--) {
            var b = bats[j];
            b.x += b.vx; drawBat(b);
            if (b.x < -60 || b.x > w + 60) bats.splice(j, 1);
          }
          raf = requestAnimationFrame(tick);
        }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { cancelAnimationFrame(raf); raf = null; }
          else if (!raf) tick();
        });
        window.addEventListener('resize', resize);
        resize(); tick();
      })();

      /* ---------- Inicio ---------- */
      var saved = store('get');
      if (saved) {
        var v = validate(saved);
        if (v.ok) state.code = v.code; else store('del');
      }
      updateBar();
      renderCode();
      refreshCart();

      // API pública: HalloweenHeader.refreshCart() desde tu tema si no se actualiza solo
      window.HalloweenHeader = { refreshCart: refreshCart, apply: applyCode, getCode: function () { return state.code; } };
    }

    function initAll() {
      var list = document.querySelectorAll('.hw');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
